import { ErrorContext, ErrorContextProvider } from "./ErrorContext";

export interface IErrorContext {
    Error?: AppError;
    SetError: (error: AppError | undefined) => void;
}

export class AppError extends Error {
    [key: string]: any;
}

export { ErrorContext, ErrorContextProvider };
